export default ({ app, router, Vue }) => {
  router.beforeEach((to, from, next) => {
    window._paq.push(['setCustomUrl', to.fullPath])
    window._paq.push(['trackPageView'])
    window._paq.push(['setDocumentTitle', document.title])
    next()
  })
}
